import { render, staticRenderFns } from "./VCascader.vue?vue&type=template&id=6529d3af&scoped=true&"
import script from "./VCascader.vue?vue&type=script&lang=js&"
export * from "./VCascader.vue?vue&type=script&lang=js&"
import style0 from "./VCascader.vue?vue&type=style&index=0&id=6529d3af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6529d3af",
  null
  
)

export default component.exports